import { compose, createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers/index";
import thunk from "redux-thunk";
import { Middleware } from "./middleware/Middleware";

import logger from 'redux-logger'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const store = createStore(
//   rootReducer,
//   composeEnhancer(applyMiddleware(thunk, logicMiddleware))
// );

export default function configureStore() {
  const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk, Middleware, logger)));
  return store;
}
